<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Charts Enterprise</h1>
					<p waBody="m" waText>Advanced chart types &mdash; gauges, heatmaps, polar charts, hierarchical visualisations, and financial instruments extending the community AG Charts plugin. Includes radial/linear gauges, candlestick, OHLC, waterfall, treemap, sunburst, sankey, and chord diagrams.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Charts Enterprise 13.1.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>AG Charts Enterprise requires a commercial license. 30-day evaluation available from ag-grid.com/license-pricing/</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:agcharts-enterprise</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.agchartsenterprise</p>
					<p waBody="s" waText>Built on: AG Charts Enterprise 13.1.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_43" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_44" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_45" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Financial charts &mdash; Candlestick, OHLC, Waterfall, Box Plot, Histogram</p>
					<p waBody="s" waColorText="quiet" waText>Gauges &mdash; Radial and Linear gauges with segmentation, targets, and scales</p>
					<p waBody="s" waColorText="quiet" waText>Polar charts &mdash; Radial Column, Radial Bar, Nightingale, Radar &#40;Line and Area&#41;</p>
					<p waBody="s" waColorText="quiet" waText>Heatmaps &mdash; color-coded grid visualizations with gradient scales</p>
					<p waBody="s" waColorText="quiet" waText>Hierarchical charts &mdash; Treemap, Sunburst, Sankey, Chord</p>
					<p waBody="s" waColorText="quiet" waText>Specialized visualizations &mdash; Funnel charts, Range Area, Range Bar</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent builders for all enterprise chart options</p>
					<p waBody="s" waColorText="quiet" waText>Advanced styling &mdash; custom colors, gradients, fills, and patterns</p>
					<p waBody="s" waColorText="quiet" waText>Interactive features &mdash; tooltips, legends, zoom, pan, highlighting</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Radial Gauge</h4>
						<p waBody="s" waColorText="quiet" waText>Create a radial gauge with min/max scale.</p>
						<markdown [data]="mdContent_46" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Candlestick Chart</h4>
						<p waBody="s" waColorText="quiet" waText>Create a financial candlestick chart.</p>
						<markdown [data]="mdContent_47" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_48" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AgChartsEnterprisePageConfigurator auto-registers ag-charts-enterprise module and license key</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>AG&#95;CHARTS&#95;LICENSE&#95;KEY</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AG Charts Enterprise license key &mdash; set via AgChartsEnterprisePageConfigurator.setAG&#95;CHARTS&#95;LICENSE&#95;KEY&#40;&#41;</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://charts.ag-grid.com/javascript/license/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://charts.ag-grid.com/javascript/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgChartsEnterprise</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>